import React from "react";
import { FiAlertTriangle, FiInfo } from "react-icons/fi";
import { RiDragDropLine } from "react-icons/ri";
import { getReceiptReimbursementEligibility } from "../../../../../../Utils/expenseReimbursement";

function ReceiptDrop({ dragging, onDrop }) {
	if (dragging?.__quickAdd) {
		return null;
	}

	if (dragging) {
		const { dropState, dropMessage } = getReceiptReimbursementEligibility(dragging);
		if (dropState === "missingCategory") {
			return (
				<div onDragOver={(e) => e.preventDefault()} className="absolute left-0 right-0 bottom-0 top-0 p-2">
					<div className={`w-full h-full transition-all bg-dark text-white rounded-xl flex-center p-6 text-sm`}>
						<div className="text-center ">
							<FiInfo size={52} className="m-auto mb-6" />
							{dropMessage}
						</div>
					</div>
				</div>
			);
		}

		if (dropState === "outOfPolicy") {
			return (
				<div onDragOver={(e) => e.preventDefault()} className="absolute left-0 right-0 bottom-0 top-0 p-2">
					<div className={`w-full h-full transition-all bg-dangerText text-white rounded-xl flex-center p-6 text-sm`}>
						<div className="text-center ">
							<FiAlertTriangle size={52} className="m-auto mb-6" />
							{dropMessage}
						</div>
					</div>
				</div>
			);
		}

		if (dropState === "eligible") {
			return (
				<div onDragOver={(e) => e.preventDefault()} onDrop={onDrop} className="absolute left-0 right-0 bottom-0 top-0 p-2">
					<div className={`w-full h-full transition-all bg-primary text-white rounded-xl flex-center p-6 text-sm`}>
						<div className="text-center ">
							<RiDragDropLine size={52} className="m-auto mb-6" />
							{dropMessage}
						</div>
					</div>
				</div>
			);
		}
	}

	return null;
}

export default ReceiptDrop;
